var _path, _path2, _rect, _rect2, _path3, _path4, _path5, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcEstateAllStep4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 61,
    viewBox: "0 0 53 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5137 31.9448L43.31 13.6543L31.4219 27.7362V60.4779H52.5137V31.9448Z",
    fill: "#BFD9F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.486328 31.2129H32.8271V60.4777H0.486328V31.2129Z",
    fill: "#EAF5FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.7344,
    y: 39.9932,
    width: 8.43672,
    height: 8.77943,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39.8574,
    y: 42.9189,
    width: 7.0306,
    height: 17.5589,
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1749 13.6543H11.5077L0.486328 31.2132H32.8271L43.1749 13.6543Z",
    fill: "#BEBEBE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9641 7.02804C20.5485 3.58745 23.2179 0.521484 26.6835 0.521484C30.1437 0.521484 32.8111 3.57704 32.399 7.01257C31.8132 11.8955 31.1327 18.3346 31.1327 21.8982C31.1327 28.1549 33.2302 33.8901 33.2302 33.8901L20.1211 33.8901C20.1211 33.8901 22.2185 28.4139 22.2185 21.8982C22.2185 18.2119 21.5472 11.8544 20.9641 7.02804Z",
    fill: "#A26138"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1738 35.0823C12.1738 29.3781 16.798 24.7539 22.5022 24.7539L30.8444 24.7539C36.5486 24.7539 41.1727 29.3781 41.1727 35.0823L12.1738 35.0823Z",
    fill: "#A26C4D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.3809,
    y: 33.8887,
    width: 30.5879,
    height: 3.17796,
    rx: 1.58898,
    fill: "#845430"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEstateAllStep4);
export default __webpack_public_path__ + "static/media/IcEstateAllStep4.40a85f934168ec187e1c0fe03d9947f7.svg";
export { ForwardRef as ReactComponent };